/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Export_Csv_TitleInputs */



/**
* | output |
* | --- |
* | "Export terms to CSV" |
*
* @param {Knp_Terms_Export_Csv_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_export_csv_title = /** @type {((inputs?: Knp_Terms_Export_Csv_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Export_Csv_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les termes en CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Begriffe in CSV exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta i termini in CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт терминов в CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar términos a CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出条款至 CSV 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("用語をCSVにエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शर्तों को CSV में निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar termos para CSV")
	return /** @type {LocalizedString} */ ("Export terms to CSV")
});